"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LwtClaim = void 0;
var AppsClaim_1 = require("./AppsClaim");
var IdentityProvidersClaim_1 = require("./claims/IdentityProvidersClaim");
var ClientClaim_1 = require("./ClientClaim");
var LwtUserType;
(function (LwtUserType) {
    LwtUserType["INTERNAL"] = "I";
    LwtUserType["CLIENT"] = "C";
    LwtUserType["APP"] = "A";
    LwtUserType["SERVICE"] = "S";
})(LwtUserType || (LwtUserType = {}));
var LwtClaim = /** @class */ (function () {
    function LwtClaim() {
        this.utp = LwtUserType.CLIENT;
        this.pfmAuth = false;
    }
    LwtClaim.prototype.populate = function (lwtClaimObject) {
        var _this = this;
        if (lwtClaimObject.pfm) {
            this.pfm = [];
            lwtClaimObject.pfm.forEach(function (pfmClient) {
                var _a;
                var platformClient = new ClientClaim_1.ClientClaim();
                platformClient.populate(pfmClient);
                (_a = _this.pfm) === null || _a === void 0 ? void 0 : _a.push(platformClient);
            });
            delete lwtClaimObject.pfm;
        }
        if (lwtClaimObject.apps) {
            this.apps = new AppsClaim_1.AppsClaim();
            this.apps.populate(lwtClaimObject.apps);
            delete lwtClaimObject.apps;
        }
        if (lwtClaimObject.idps) {
            this.idps = new IdentityProvidersClaim_1.IdentityProvidersClaim();
            this.idps.populate(lwtClaimObject.idps);
            delete lwtClaimObject.idps;
        }
        Object.assign(this, lwtClaimObject);
    };
    LwtClaim.prototype.isInternalToken = function () {
        return this.utp === LwtUserType.INTERNAL;
    };
    LwtClaim.prototype.isClientToken = function () {
        return this.utp === LwtUserType.CLIENT;
    };
    LwtClaim.prototype.isAppToken = function () {
        return this.utp === LwtUserType.APP;
    };
    LwtClaim.prototype.isServiceToken = function () {
        return this.utp === LwtUserType.SERVICE;
    };
    LwtClaim.prototype.getUserId = function () {
        return this.uid;
    };
    LwtClaim.prototype.getUserType = function () {
        return this.utp;
    };
    LwtClaim.prototype.getSessionId = function () {
        return this.sid;
    };
    LwtClaim.prototype.getGroups = function () {
        return this.groups;
    };
    LwtClaim.prototype.getClients = function () {
        return this.pfm;
    };
    LwtClaim.prototype.getAppsClaim = function () {
        return this.apps;
    };
    LwtClaim.prototype.getIdentityProvidersClaim = function () {
        return this.idps;
    };
    LwtClaim.prototype.getPersonalClient = function () {
        var _a;
        return (_a = this.pfm) === null || _a === void 0 ? void 0 : _a.find(function (client) { return client.getType() === 'User'; });
    };
    LwtClaim.prototype.getPfmAuth = function () {
        return this.pfmAuth;
    };
    return LwtClaim;
}());
exports.LwtClaim = LwtClaim;
